z<template>
  <Modal title="老师课程请假" v-model="visible">
    <Form ref="dataForm" class="form"
          :model="formData" :rules="rule"
          :label-width="80">
      <Row>
        <Col span="4">
        <FormItem label="请假类型：" >
          <Select v-model="formData.leaveType"  style="width:180px">
            <Option :value=1>常规请假Standard leave</Option>
            <Option :value=2>临时请假 Emergency leave</Option>
            <Option :value=4>老师失联NCNS</Option>
            <Option :value=5>取消课Cancellation</Option>
          </Select>
        </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="4" style="height: 50px; width: 400px">
        <span  style="margin:0px 20px;">请假课程：{{formData.beginTime}}</span>
        <span>{{formData.title}}</span>
        </Col>
      </Row>
      <Row>
        <Col :span="22">
        <Form-item label="请假原因：" prop="remark">
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                 placeholder="长度不要超过100个字符"
                 v-model="formData.remark" ></Input>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAdd" @click="onTchLeave">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'TchLessonLeaveModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      title: {
        type: String,
        default: false
      },
      beginTime: {
        type: Number,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        formData: {
          remark: '',
          leaveType: 1,
          beginTime: '',
          title: ''
        },
        loadingAdd: false,
        rule: {
          remark: [
            { type: 'string', required: true, message: '请填写请假原因', trigger: 'blur' },
            { type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      onTchLeave () {
        let self = this
        self.loadingAdd = true
        self.$refs.dataForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingAdd = false
            return
          }
          self.formData.openedId = self.openedId
          self.$http.post('/bookTchLeaveTime/addByOpenedId', self.formData).then(function (res) {
            self.loadingAdd = false
            if (res) {
              self.$Message.success('请假成功!')
              self.visible = false
              self.successCallback()
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === true) {
          this.formData.remark = ''
        }
        this.$emit('input', val)
      },
      title (val) {
        this.formData.title = val
      },
      beginTime (val) {
        let $moment = this.$moment
        this.formData.beginTime = $moment(val, 'X').format('YYYY-MM-DD HH:mm')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TchLessonLeaveModal.vue?38ba0a50